angular.module('tgaAdmin').controller('UsersReportModalController', [
  '$scope',
  '$timeout',
  '$uibModalInstance',
  '$uibModalStack',
  'reportService',
  'extras',
  '$log',
  function (
    $scope,
    $timeout,
    $uibModalInstance,
    $uibModalStack,
    reportService,
    extras,
    $log,
  ) {
    $scope.data = {
      alerts: [],
      closeButton: true,
      report: extras.report,
    };

    $scope.viewmodel = {
      modal_title: 'Processing Report...',
      report_id: null,
      progress: 0,
      download: null,
    };

    $scope.initialize = function () {
      $scope.loading = true;
      reportService
        .addReportToQueue({
          report_type: extras.report.report_type,
          start_date: extras.report.start_date,
          end_date: extras.report.end_date,
        })
        .then((response) => {
          $scope.viewmodel.report_id = response.report_id;
          $scope.actions.watchReport();
        })
        .catch((error) => {
          $log.error('Unable to add report.', error);
          $scope.loading = false;
        });
    };

    $scope.actions = {
      watchReport() {
        reportService
          .getProgress($scope.viewmodel.report_id)
          .then((response) => {
            $scope.viewmodel.progress = response.progress;

            if ($scope.viewmodel.progress > 0) {
              $scope.loading = false;
            }

            if (response.url) {
              $scope.viewmodel.download = response.url;
              $scope.viewmodel.modal_title = 'Your report is ready!';
            } else {
              $scope.timer = $timeout(() => {
                $scope.actions.watchReport();
              }, 2000);
            }
          })
          .catch(() => {
            $scope.timer = $timeout(() => {
              $scope.actions.watchReport();
            }, 3000);
          });
      },
      createAlert(msg, type) {
        $scope.data.alerts = [];
        $scope.data.alerts.push({
          msg,
          type,
        });
      },
      close() {
        $uibModalInstance.dismiss();
      },
    };

    $scope.$on('$destroy', () => {
      // Cancel timer when modal closes
      $timeout.cancel($scope.timer);
    });

    $scope.initialize();
  },
]);
